var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-jumbotron", {
        attrs: { lead: _vm.$t("label.bo_change_password") },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login" },
        [
          [
            _c("h3", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("label.password_update"))),
            ]),
            _vm._v(" "),
            !_vm.forgotedpwd
              ? _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "g_input-password_old",
                      label: _vm.$t("label.password_old"),
                      "label-for": "input-password_old",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "input-password_old",
                        type: "password",
                        required: "",
                      },
                      model: {
                        value: _vm.formData.oldPwd,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "oldPwd", $$v)
                        },
                        expression: "formData.oldPwd",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "g_input-password",
                  label: _vm.$t("label.password_new"),
                  "label-for": "input-password_new",
                },
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "input-password_new",
                    type: "password",
                    state: _vm.isValid,
                    required: "",
                  },
                  model: {
                    value: _vm.formData.newPwd,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "newPwd", $$v)
                    },
                    expression: "formData.newPwd",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "g_input-password_confirm",
                  label: _vm.$t("label.password_confirm"),
                  "label-for": "input-password_confirm",
                },
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "input-password_confirm",
                    type: "password",
                    state: _vm.isMatchValid,
                    required: "",
                  },
                  model: {
                    value: _vm.formData.confirmPwd,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "confirmPwd", $$v)
                    },
                    expression: "formData.confirmPwd",
                  },
                }),
                _vm._v(" "),
                _vm.formData.confirmPwd !== "" && !_vm.isMatchValid
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("error.no_match_password")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            true && _vm.policyCriteria
              ? _c(
                  "b-row",
                  { staticClass: "mt-3 bd-callout" },
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-alert",
                          {
                            attrs: {
                              variant: "blue",
                              show: !_vm.isValidPassword,
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { attrs: { "align-v": "center" } },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "icon",
                                      attrs: { icon: ["fas", "info"] },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-col", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("alert.password.info"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", [
                                    _c(
                                      "li",
                                      {
                                        style: _vm.getColorPwdRule(
                                          _vm.state.pwdLengthOk
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.policyCriteria.size.max
                                                ? _vm.$t(
                                                    "alert.password.lenght_with_max",
                                                    [
                                                      _vm.policyCriteria.size
                                                        .min,
                                                      _vm.policyCriteria.size
                                                        .max,
                                                    ]
                                                  )
                                                : _vm.$t(
                                                    "alert.password.info_lenght",
                                                    [
                                                      _vm.policyCriteria.size
                                                        .min,
                                                    ]
                                                  )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.policyCriteria.char.upper.authorized
                                      ? _c(
                                          "li",
                                          {
                                            style: _vm.getColorPwdRule(
                                              _vm.state.pwdUpperOk
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.policyCriteria.char.upper
                                                    .max
                                                    ? _vm.$t(
                                                        "alert.password.info_upper_char_with_max",
                                                        [
                                                          _vm.policyCriteria
                                                            .char.upper.min,
                                                          _vm.policyCriteria
                                                            .char.upper.max,
                                                        ]
                                                      )
                                                    : _vm.$t(
                                                        "alert.password.info_upper_char",
                                                        [
                                                          _vm.policyCriteria
                                                            .char.upper.min,
                                                        ]
                                                      )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.policyCriteria.char.lower.authorized
                                      ? _c(
                                          "li",
                                          {
                                            style: _vm.getColorPwdRule(
                                              _vm.state.pwdLowerOk
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.policyCriteria.char.lower
                                                    .max
                                                    ? _vm.$t(
                                                        "alert.password.info_lower_char_with_max",
                                                        [
                                                          _vm.policyCriteria
                                                            .char.lower.min,
                                                          _vm.policyCriteria
                                                            .char.lower.max,
                                                        ]
                                                      )
                                                    : _vm.$t(
                                                        "alert.password.info_lower_char",
                                                        [
                                                          _vm.policyCriteria
                                                            .char.lower.min,
                                                        ]
                                                      )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.policyCriteria.number.authorized
                                      ? _c(
                                          "li",
                                          {
                                            style: _vm.getColorPwdRule(
                                              _vm.state.pwdNumberOk
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.policyCriteria.number.max
                                                    ? _vm.$t(
                                                        "alert.password.info_number_with_max",
                                                        [
                                                          _vm.policyCriteria
                                                            .number.min,
                                                          _vm.policyCriteria
                                                            .number.max,
                                                        ]
                                                      )
                                                    : _vm.$t(
                                                        "alert.password.info_number",
                                                        [
                                                          _vm.policyCriteria
                                                            .number.min,
                                                        ]
                                                      )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.policyCriteria.special.authorized
                                      ? _c(
                                          "li",
                                          {
                                            style: _vm.getColorPwdRule(
                                              _vm.state.pwdSpecialOk
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getSpecialPasswordText
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-container",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: _vm.isValidPassword
                                ? "primary"
                                : "secondary",
                              title: _vm.$t("btn.reset"),
                              disabled: !_vm.isValidPassword,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.changePwd()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("btn.reset")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }